<div class="language-selector-container">
  <button
    [matMenuTriggerFor]="menu"
    class="menuBtn"
    (menuOpened)="isMenuActive = true"
    (menuClosed)="isMenuActive = false"
  >
    <div class="language-selector-btn-content">
      <p class="language-selector-language-label">
        {{ getLanguageCode() }}
      </p>
      <img
        src="assets/images/dropdown-arrow-icon.svg"
        class="dropdown-icon active"
        alt="down arrow icon"
        [ngStyle]="{
          transform: isMenuActive ? 'ScaleY(-1)' : 'ScaleY(1)',
          transition: isMenuActive
            ? 'transform 0.3s ease-in-out'
            : 'transform 0.3s ease-in-out'
        }"
      />
    </div>
  </button>
  <mat-menu
    #menu="matMenu"
    xPosition="before"
    class="language-selector-mat-menu-content"
  >
    <button
      *ngFor="let lang of languages"
      mat-menu-item
      class="language-selector-mat-menu-item"
      (click)="switchLanguage(lang.code)"
    >
      {{ labels.stellar.languageSelector[lang.cmsKey] }}
    </button>
  </mat-menu>
</div>
